import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounce } from 'lodash';
@Component({
  selector: 'concourse-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {
  public reset() {
    this.searchQuery = ''
  }

  @Input('dataSource') dataSource = [];
  @Input('allowDebounce') allowDebounce = false;
  @Output('onSearchFilter') searchFilter = new EventEmitter();
  @Output('onSearchValue') searchValue = new EventEmitter();
  @Output('onSearchSubmit') searchSubmit = new EventEmitter();
  filterResult = [];
  searchQuery = "";

  constructor() { }

  ngOnInit(): void {
  }

  filterItem(value) {
    if (!value) {
      this.assignCopy();
    } // when nothing has typed
    this.filterResult = Object.assign([], this.dataSource).filter(
      item => JSON.stringify(item).toLowerCase().indexOf(value.toLowerCase()) > -1
    );
    this.searchFilter.emit(this.filterResult);
  }

  assignCopy() {
    this.filterResult = Object.assign([], this.dataSource);
  }


  validateInput(event) {
    // const pattern = /^[A-Za-z0-9]+$/;
    // const inputChar = String.fromCharCode(event.charCode);
    // if (!pattern.test(inputChar)) {
    //    event.preventDefault();
    // }
  }

  submitInput(value) {
    this.searchValue.emit(value);
  }

  searchByKey(event) {
    if (event.key === "Enter") {
      this.submitSearch();
    }
  }

  submitSearch() {
    this.searchSubmit.emit(true);
  }
  debouncedSearch = debounce((value) => {
    this.searchValue.emit(value);
    this.searchSubmit.emit(true);
  }, 1000);

}
